import React from "react";
import {
  Button,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import Layout from "../../components/Layout";
import { payoutService } from "./service";
import { PayoutGridRow } from "../../types/payouts";

const Payouts = () => {
  const navigate = useNavigate();
  const [search, setSearch] = React.useState("");
  const [rows, setRows] = React.useState<PayoutGridRow[]>([]);
  const [loading, setLoading] = React.useState(false);

  const fetchRows = React.useCallback(async (query = "") => {
    setLoading(true);
    try {
      const data = await payoutService.fetchGrid(query);
      setRows(Array.isArray(data) ? data : []);
    } finally {
      setLoading(false);
    }
  }, []);

  React.useEffect(() => {
    fetchRows("");
  }, [fetchRows]);

  return (
    <Layout appBarTitle="Payouts">
      <Paper sx={{ p: 3 }}>
        <Stack direction={{ xs: "column", sm: "row" }} spacing={2} mb={3}>
          <TextField
            label="Search specialist"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            fullWidth
          />
          <Button variant="contained" onClick={() => fetchRows(search)} disabled={loading}>
            Apply Filter
          </Button>
        </Stack>

        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Specialist</TableCell>
                <TableCell>Email</TableCell>
                <TableCell>Phone</TableCell>
                <TableCell>Specialization</TableCell>
                <TableCell>Total</TableCell>
                <TableCell>Paid</TableCell>
                <TableCell>Due</TableCell>
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((row) => (
                <TableRow key={row.specialistId}>
                  <TableCell>{row.name}</TableCell>
                  <TableCell>{row.email || "-"}</TableCell>
                  <TableCell>{row.phone || "-"}</TableCell>
                  <TableCell>{row.specialization || "-"}</TableCell>
                  <TableCell>{row.total}</TableCell>
                  <TableCell>{row.paid}</TableCell>
                  <TableCell>{row.due}</TableCell>
                  <TableCell>
                    <Button
                      variant="outlined"
                      onClick={() => navigate(`/payouts/${row.specialistId}`)}
                    >
                      Manage
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
              {!rows.length ? (
                <TableRow>
                  <TableCell colSpan={8}>
                    <Typography variant="body2">No payout records found.</Typography>
                  </TableCell>
                </TableRow>
              ) : null}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </Layout>
  );
};

export default Payouts;
